import dispatcher from '../dispatcher';
import popupStore from '../popup/popup.store';

var elementProto = Object.create(HTMLAnchorElement.prototype);

function getMobileOperatingSystem() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
		return 'iOS';
	} else if (userAgent.match(/Android/i)) {
		return 'Android';
	} else {
		return 'unknown';
	}
}

var _handleMouseenter = function() {
	dispatcher.dispatch({
		type: 'map:move',
		lat: parseFloat(this._lat),
		lng: parseFloat(this._lng)
	});
	dispatcher.dispatch({
		type: 'map:set-fake',
		element: this
	});
	dispatcher.dispatch({
		type: 'popup:open',
		id: this._id
	});
}

var _handleMouseleave = function() {
}

var _handleClick = function() {
	if (Modernizr.mobile) {

	} else {
		dispatcher.dispatch({
			type: 'popup:open',
			id: this._id
		});
	}
}

elementProto.createdCallback = function() {
	this.handleMouseenter = _handleMouseenter.bind(this);
	this.handleMouseleave = _handleMouseleave.bind(this);
	this.handleClick = _handleClick.bind(this);
}
elementProto.attachedCallback = function() {
	var lat  = this.getAttribute('data-lat')  || 0;
	var lng  = this.getAttribute('data-lng')  || 0;
	var operatingSystem = getMobileOperatingSystem();

	this._id = this.getAttribute('data-id');
	this._lat = lat;
	this._lng = lng;

	if (operatingSystem.toLowerCase() === 'android') {
		this.setAttribute('href', 'https://yandex.ru/maps/?pt=' + lng + ',' + lat + '&z=17&l=map');
	} else if (operatingSystem.toLowerCase() === 'ios') {
		this.setAttribute('href', 'https://maps.apple.com/?q=' + lat + ',' + lng);
	} else {
		this.setAttribute('href', 'https://yandex.ru/maps/?pt=' + lng + ',' + lat + '&z=17&l=map');
	}

	if (!Modernizr.mobile) {
		this.addEventListener('mouseenter', this.handleMouseenter);
		this.addEventListener('mouseleave', this.handleMouseleave);
		this.addEventListener('click', this.handleClick);
	}
}
elementProto.detachedCallback = function() {
}

document.registerElement('contacts-link', {
	prototype: elementProto,
	extends: 'a'
});